import notie from 'notie'
import 'notie/dist/notie.css'

export default {
  success(msg) {
    notie.alert({ type: 'success', text: msg, position: 'bottom' })
  },

  error(msg) {
    notie.alert({ type: 'error', text: msg, position: 'bottom', stay: true })
  },

  info(msg) {
    notie.alert({ type: 'info', text: msg, position: 'bottom' })
  },

  warning(msg) {
    notie.alert({ type: 'warning', text: msg, position: 'bottom' })
  },

  
}